import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/pages/Layout/Layout'

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  /*base: '',*/
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
      {
        path: '/',
        component: () => import('@/pages/Home/Home'),
        meta: {
          menuIndex: 5
        }
      },
      {
        path: 'login',
        component: () => import('@/pages/Login'),
      },
      {
        path: 'register',
        component: () => import('@/pages/Register'),
      },
      {
        path: 'findpwd',
        component: () => import('@/pages/User/RetrievePassword'),
      }]
    },
    {
      path: '/home',
      component: Layout,
      children: 
      [{
        path: '/',
        component: () => import('@/pages/Home/Home'),
        meta: {
          menuIndex: 5
        }
      }]
    },
    {
      path: '/products',
      component: Layout,
      children: 
      [{
        path: '/',
        component: () => import('@/pages/Products/Products'),
        meta: {
          menuIndex: 4
        }
      },
      {
        path: 'details',
        component: () => import('@/pages/Products/ProductDetails'),
        meta: {
          menuIndex: 4
        }
      }]
    },
    {
      path: '/solutions',
      component: Layout,
      children: 
      [{
        path: '/',
        component: () => import('@/pages/Solutions/SolNew'),
        meta: {
          menuIndex: 3
        }
      },
      {
        path: 'detail',
        component: () => import('@/pages/Solutions/SolutionsDetail'),
        meta: {
          menuIndex: 3
        }
      }]
    },
    {
      path: '/news',
      component: Layout,
      children: 
      [{
        path: '/',
        component: () => import('@/pages/News/News'),
        meta: {
          menuIndex: 6
        }
      }]
    },
    {
      path: '/training',
      component: Layout,
      children: 
      [{
        path: '/',
        component: () => import('@/pages/TrainingTemp/Training'),
        meta: {
          menuIndex: 3
        }
      },
      {
        path: 'schedule',
        component: () => import('@/pages/TrainingTemp/TrainingSchedule'),
        meta: {
          menuIndex: 3
        }
      },
      {
        path: '9527',
        component: () => import('@/pages/Training/Training'),
        meta: {
          menuIndex: 3
        }
      }]
    },
    {
      path: '/resources',
      component: Layout,
      children: 
      [{
        path: '/',
        component: () => import('@/pages/Rescources/Resources'),
        meta: {
          menuIndex: 2
        }
      }]
    },
    {
      path: '/aboutus',
      component: Layout,
      children: 
      [{
        path: '/',
        component: () => import('@/pages/AboutUs/About'),
        meta: {
          menuIndex: 1
        }
      }]
    },
    {
      path: '/contact',
      component: Layout,
      children: 
      [{
        path: '/',
        component: () => import('@/pages/Contact/Contact'),
        meta: {
          menuIndex: 0
        }
      }]
    },
    {
      path: '/user',
      component: Layout,
      children: 
      [{
        path: '/',
        redirect: '/user/center'
      },
      {
        path: 'center',
        component: () => import('@/pages/User/UserCenter'),
        meta: {
          loginRequired: true
        }
      },
      {
        path: 'resetpwd',
        component: () => import('@/pages/User/ResetPassword'),
        meta: {
          loginRequired: true
        }
      },
      {
        path: 'editphone',
        component: () => import('@/pages/User/ChangePhone'),
        meta: {
          loginRequired: true
        }
      }]
    },
    {
      path: '/shopping',
      component: Layout,
      children: 
      [{
        path: '/',
        redirect: '/shopping/cart'
      },
      {
        path: 'cart',
        component: () => import('@/pages/Shopping/ShoppingCart'),
        meta: {
          loginRequired: true
        },
      },
      {
        path: 'quotation',
        component: () => import('@/pages/Shopping/ShoppingQuotation'),
        meta: {
          loginRequired: true
        },
      }]
    },
    {
      path: '/address',
      component: Layout,
      children: 
      [{
        path: '/',
        redirect: '/address/manage'
      },
      {
        path: 'manage',
        component: () => import('@/pages/Address/AddressManage'),
        meta: {
          loginRequired: true
        },
      },
      {
        path: 'set',
        component: () => import('@/pages/Address/AddressSet'),
        meta: {
          loginRequired: true
        },
      }]
    },
    {
      path: '/order',
      component: Layout,
      children: 
      [{
        path: '/',
        redirect: '/order/center'
      },
      {
        path: 'center',
        component: () => import('@/pages/Order/OrderCenter'),
        meta: {
          loginRequired: true
        },
      },
      {
        path: 'detail',
        component: () => import('@/pages/Order/OrderDetail'),
        meta: {
          loginRequired: true
        },
      },
      {
        name: 'OrderComfirm',
        path: 'confirm',
        component: () => import('@/pages/Order/OrderConfirm'),
        meta: {
          loginRequired: true
        },
      }]
    },
    {
      path: '/payment',
      component: Layout,
      children: 
      [{
        path: '/',
        component: () => import('@/pages/Payment/Payment'),
        meta: {
          loginRequired: true
        },
      },
      {
        path: 'success',
        component: () => import('@/pages/Payment/PaySuccess'),
        meta: {
          loginRequired: true
        },
      },
      {
        path: 'failure',
        component: () => import('@/pages/Payment/PayFailure'),
        meta: {
          loginRequired: true
        },
      }]
    },
    {
      path: '/gift',
      component: Layout,
      children: 
      [{
        path: '/',
        redirect: '/gift/center'
      },
      {
        path: 'center',
        component: () => import('@/pages/Gift/GiftCenter'),
        meta: {
          loginRequired: true,
          title: '礼品中心'
        },
      },
      {
        path: 'mine',
        component: () => import('@/pages/Gift/GiftMine'),
        meta: {
          loginRequired: true,
          title: '我的礼品'
        },
      },
      {
        path: 'record',
        component: () => import('@/pages/Gift/GiftRecord'),
        meta: {
          loginRequired: true,
          title: '积分记录'
        },
      },
      {
        path: 'detail',
        component: () => import('@/pages/Gift/GiftDetail'),
        meta: {
          loginRequired: true,
          title: '礼品详情'
        },
      }]
    },
    {
      path: '/404',
      redirect: '/'
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js